export function Services({ data }) {
  return (
    <div className="flex flex-col gap-4 mx-10 pb-10 mt-5  [&_ol]:!list-[auto] [&_ol]:p-[revert] [&_ol]:m-[revert]">
      <div
        dangerouslySetInnerHTML={{
          __html: data?.services,
        }}
      />
      <div className="w-full h-auto">
        <img src={data?.servicesImg} className="w-full h-auto object-cover" />
      </div>
    </div>
  );
}
